var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCityOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.9168 46.678C37.9168 45.0672 39.2226 43.7614 40.8334 43.7614H46.6668C48.2776 43.7614 49.5834 45.0672 49.5834 46.678C49.5834 48.2888 48.2776 49.5947 46.6668 49.5947H40.8334C39.2226 49.5947 37.9168 48.2888 37.9168 46.678Z",
    fill: "#6BCF7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9168 33.553C37.9168 31.9422 39.2226 30.6364 40.8334 30.6364H46.6668C48.2776 30.6364 49.5834 31.9422 49.5834 33.553C49.5834 35.1638 48.2776 36.4697 46.6668 36.4697H40.8334C39.2226 36.4697 37.9168 35.1638 37.9168 33.553Z",
    fill: "#6BCF7F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8334 17.5114C39.2226 17.5114 37.9168 18.8172 37.9168 20.428C37.9168 22.0388 39.2226 23.3447 40.8334 23.3447H46.6668C48.2776 23.3447 49.5834 22.0388 49.5834 20.428C49.5834 18.8172 48.2776 17.5114 46.6668 17.5114H40.8334Z",
    fill: "#6BCF7F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2501 46.678C26.2501 48.2888 24.9442 49.5947 23.3334 49.5947H17.5001C15.8893 49.5947 14.5834 48.2888 14.5834 46.678C14.5834 45.0672 15.8893 43.7614 17.5001 43.7614H23.3334C24.9442 43.7614 26.2501 45.0672 26.2501 46.678Z",
    fill: "#6BCF7F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0834 2.91663C28.8618 2.91663 26.2501 5.5283 26.2501 8.74996V29.1666H14.5834C11.3618 29.1666 8.75008 31.7783 8.75008 35V58.3333H5.83342C4.22258 58.3333 2.91675 59.6391 2.91675 61.25C2.91675 62.8608 4.22258 64.1666 5.83342 64.1666H64.1668C65.7776 64.1666 67.0834 62.8608 67.0834 61.25C67.0834 59.6391 65.7776 58.3333 64.1668 58.3333H61.2501V8.74996C61.2501 5.5283 58.6384 2.91663 55.4168 2.91663H32.0834ZM55.4168 58.3333V8.74996H32.0834V58.3333H55.4168ZM26.2501 35H14.5834V46.678V58.3333H26.2501V46.678V35Z",
    fill: "#6BCF7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCityOne);
export default __webpack_public_path__ + "static/media/city-one.9aa3283ce66c7ff963d79ec9202f8f25.svg";
export { ForwardRef as ReactComponent };